import { useMemo } from 'react';
import type { PropsWithChildren } from 'react';

import { AuthBaseUrlContextProvider } from '@opendoor/auth-fe/context';

import { useObservability } from '../../helpers/observability';
import { getAthenaClient } from '../api';
import { COSMOS_URL } from '../globals';
import { fromGraphqlRequestClient } from './fromGraphqlRequestClient';
import { recordRegistrationSmsConsent } from './registrationSmsConsent';

const AuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const client = useMemo(() => fromGraphqlRequestClient(getAthenaClient()), []);
  const { trackError } = useObservability();

  return (
    <AuthBaseUrlContextProvider
      authBaseUrl={COSMOS_URL}
      client={client}
      analyticsPrefix="cosmos"
      trackError={trackError}
      recordMarketingSmsConsent={recordRegistrationSmsConsent}
    >
      {children}
    </AuthBaseUrlContextProvider>
  );
};

export default AuthProvider;
